import { useEffect } from 'react'
import {
    useLocation,
} from 'react-router-dom'

import {
    useQuery,
} from '@tanstack/react-query'

import preCheckClientViewMutation from './services/pre-check-client-view'
import IdResultView from '../../Components/IdResultView'
import { trackEvent } from '../../utils/analytics'

const PreCheckView = () => {
    const location = useLocation()

    const queryParams = new URLSearchParams(location.search)
    const key = queryParams.get('key')

    const {
        data,
        error,
        isFetching,
    } = useQuery({
        queryKey: ['pre-check-client-view', key],
        queryFn: () => preCheckClientViewMutation({ key }),
        refetchOnWindowFocus: false,
    })

    // Fire once the card data arrives successfully.
    useEffect(() => {
        if (data) {
            trackEvent('trucheck_card_view', { viewer_role: 'client', source: 'client_view' })
        }
    }, [data])

    return (
        <IdResultView
            data={data}
            referenceId={key}
            isFetching={isFetching}
            error={error}
            viewerRole="client"
        />
    )
}

export default PreCheckView
